<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import { SasRadioGroup } from '@/core/ui';

@Component
export default class AppRadioGroup extends SasRadioGroup {
  /**
   * 拡張設定
   * api: オプション値を取得するAPIのURL
   */
  @Prop({required: false})
  options;

  /**
   * 拡張設定
   */
  @Prop({required: false, type: Boolean})
  readonly;

  get border () {
    if (this.options && 'border' in this.options) {
      return this.options.border;
    }
    return false;
  }

  get button () {
    if (this.options && 'button' in this.options) {
      return this.options.button;
    }
    return false;
  }

  /**
   * 選択オプションを取得する
   * 選択オプションは、options.url で指定されたAPIから取得する。
   */
  fetchOptionsImpl () {
    let fetchPromise = null;
    if (this.options.static !== undefined && this.options.static !== null) {
      // 静的
      const staticResult = {
        data: {
          results: {
            list: this.options.static
          }
        }
      };
      fetchPromise = Promise.resolve().then(() => staticResult);
    } else {
      // API呼出
      const cache = (this.options.global) ? this.$_sas.$cache.global : this.$_sas.$cache;
      const url = this.options.api;
      fetchPromise = cache.segment(url).get(null, () => {
        return this.$_sas.$api.cancel().get(url);
      });
    }

    return fetchPromise.then(response => {
      let options = [];

      // データ変換
      if ('filter' in this.options) {
        options = this.options.filter(response.data.results);
      } else {
        options = response.data.results.list;
      }

      // 選択値追加
      if ('before-options' in this.options) {
        options.unshift(...this.options['before-options']);
      }
      if ('after-options' in this.options) {
        options.push(...this.options['after-options']);
      }

      return options;
    });
  }

  // クラス
  get customClass () {
    let optionClass = (this.options && 'class' in this.options) ? this.options.class : [this.defaultSize];
    if (this.computedReadonly) {
      if (!Array.isArray(optionClass)) {
        optionClass = [optionClass];
      }
      optionClass.push('is-readonly');
    }
    return optionClass;
  }

  /**
   * disabled
   */
  get isDisabled () {
    // プロパティ優先
    if (this.disabled === true || this.disabled === 'true') {
      return true;
    }
    const disabled = (this.options && 'disabled' in this.options) ? this.options.disabled : false;
    return disabled || this.computedReadonly;
  }

  /**
   * readonly
   */
  get computedReadonly () {
    // プロパティ優先
    if (this.readonly === true || this.readonly === 'true') {
      return true;
    }
    const readonly = (this.options && 'readonly' in this.options) ? this.options.readonly : false;
    return readonly;
  }

  onChange (...args) {
    // 変更前の値はundefined固定
    this.$emit('app-event', 'change', this, undefined, args[0]);

    // 値が変更されたタイミングでバリデーションを要求する
    this.$emit('app-event', 'require:validate', this, ...args);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/radio/AppRadioGroup.vue